module.exports = __webpack_public_path__ + "static/media/logo.78c51045.png";